// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","Divider":"App_Divider__LqnLR","Loader":"App_Loader__9yOHF","Sidebar":"App_Sidebar__FlZTc"};